<script>
import { exportAutoClockOutData, getAutoClockOutData, getAutoClockOutFilters } from '@/api/service'
import DateHelpers from '@/mixins/DateHelpers'
import download from 'downloadjs'
import { DateTime } from 'luxon'
import FormattingHelpers from '@/mixins/FormattingHelpers'
import {
  PresetFilter, DateFromFilter, DateToFilter, MechanicFilter
} from '@/components/service/filters'
import { mapGetters } from 'vuex'
import FixableErrorsPanel from '@/components/service/FixableErrorsPanel.vue'
import FixableErrorsMissingTimeTrackings from '@/components/service/FixableErrorsMissingTimeTrackings.vue'

export default {
  components: {
    'mia-fixable-errors-panel': FixableErrorsPanel,
    'mia-fixable-errors-missing-time-trackings': FixableErrorsMissingTimeTrackings,
    'mia-preset-filter': PresetFilter,
    'mia-date-from-filter': DateFromFilter,
    'mia-date-to-filter': DateToFilter,
    'mia-mechanic-filter': MechanicFilter
  },

  mixins: [DateHelpers, FormattingHelpers],

  data() {
    return {
      employees: [],
      shouldRender: true
    }
  },

  computed: {
    ...mapGetters('service', ['globalFilters'])
  },

  created() {
    this.loadFilters()

    if (!this.isAllowed('moderate_service_mechanics')) {
      this.$store.commit('service/setGlobalMechanic', this.authUser.item_zls_id)
    }
  },

  methods: {
    async loadFilters() {
      this.$wait.start('loading filters')
      const [error, response] = await getAutoClockOutFilters()
      this.$wait.end('loading filters')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Filter konnten nicht geladen werden']
        })
        return
      }

      this.employees = response.employees
    },

    async loadAutoClockOutData() {
      this.$wait.start('loading auto clock out data')
      const [error, response] = await getAutoClockOutData({
        date_from: this.globalFilters.dateFrom || null,
        date_to: this.globalFilters.dateTo || null,
        employee: this.globalFilters.mechanic || null
      })
      this.$wait.end('loading auto clock out data')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Kennzahlen konnten leider nicht geladen werden']
        })
        return
      }

      this.autoClockOutData = response
    },

    async exportResult() {
      if (this.$wait.is('exporting auto clock out data')) {
        return
      }

      this.$wait.start('exporting auto clock out data')
      const [error, excelBinary] = await exportAutoClockOutData({
        date_from: this.globalFilters.dateFrom || null,
        date_to: this.globalFilters.dateTo || null,
        employee: this.globalFilters.mechanic || null
      })
      this.$wait.end('exporting auto clock out data')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Daten konnten nicht exportiert werden']
        })
        return
      }

      download(excelBinary, `${DateTime.local().toFormat('yyyy-MM-dd')}-Automatisch-Ausgestempelt.xls`, excelBinary.type)

      window.eventBus.$emit('mia-info', {
        info: ['Daten erfolgreich exportiert']
      })
    },

    onFilterChange() {
      this.shouldRender = false

      this.$nextTick(() => {
        this.shouldRender = true
      })
    }
  }
}
</script>

<template>
  <div>
    <div class="grid grid-cols-4 gap-6 p-4 bg-gray-200">
      <mia-preset-filter @preset-changed="onFilterChange" />
      <mia-date-from-filter @blur-with-change="onFilterChange" />
      <mia-date-to-filter @blur-with-change="onFilterChange" />
      <mia-mechanic-filter
        v-if="isAllowed('moderate_service_mechanics')"
        :mechanics="employees"
        @change="onFilterChange"
      />
    </div>

    <div
      v-if="shouldRender"
      class="mt-6"
    >
      <mia-fixable-errors-panel title="Fehlende Einträge in der Zeiterfassung">
        <mia-fixable-errors-missing-time-trackings />
      </mia-fixable-errors-panel>
    </div>
  </div>
</template>
